<div class="layout-breadcrumb-container">
  <div class="layout-breadcrumb-left-items">
    <p-breadcrumb [model]="items" styleClass="layout-breadcrumb py-2"></p-breadcrumb>
  </div>
  <div class="layout-breadcrumb-right-items">

  </div>
</div>
